import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createDeletePermissionUseCase({ membershipRepository }: Deps) {
  return async function deletePermission(id: string): Promise<void> {
    return membershipRepository.deletePermission(id);
  };
}
